import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../../WorkoutTemplateBuilder'

export default function AddSetButton({ phase, phaseIndex, exerciseIndex }) {
    const { mode, mutateExercise } = useContext(WorkoutTemplateBuilderContext)

    if (mode === 'edit' && phase.type === 'straight') {
        return (
            <button onClick={() => mutateExercise('add-set', phaseIndex, exerciseIndex)} className="h-10 w-full border-t border-stone-400 text-gray-500 hover:bg-gray-200">
                + Add Set
            </button>
        )
    }
}
